exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media screen and (max-width:991px){.mbPagination[data-v-5879913c]{text-align:right;float:right}.mbPagination span[data-v-5879913c]{display:inline-block;margin:0 5px}}", "", {"version":3,"sources":["/app/src/components/common/listingPagination.vue"],"names":[],"mappings":"AACA,oCACA,+BACI,iBAAkB,AAClB,WAAa,CAChB,AACD,oCACI,qBAAsB,AACtB,YAAc,CACjB,CACA","file":"listingPagination.vue","sourcesContent":["\n@media screen and (max-width: 991px) {\n.mbPagination[data-v-5879913c] {\n    text-align: right;\n    float: right;\n}\n.mbPagination span[data-v-5879913c] {\n    display: inline-block;\n    margin: 0 5px;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5879913c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/listingPagination.vue
// module id = 1145
// module chunks = 15 17 25 28 36 37 54